// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const VARIABLE_TEMPLATE_INPUT_TABLE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.VARIABLE_TEMPLATE_INPUT_TABLE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Reference dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      name: {
        kind: 'string',
        required: true
      },
      description: {
        kind: 'string',
        required: false
      },
      requireColumnMapping: {
        kind: 'boolean',
        required: true
      },
      datasetId: {
        kind: 'domain',
        required: true,
        types: [
          'DATASET'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
